var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq-item",class:{'is-expanded': _vm.is.expanded}},[_c('div',{staticClass:"faq-item-question",on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.question))]),_c('div',{staticClass:"faq-item-answer"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }